import { IconArrow } from '../../../../../../../../../assets/DesignSystem/SVGComponents';
import AssetLocationDisplay from '../../../../../../../../../components/AssetLocationDisplay/AssetLocationDisplay';
import { IToolHistoryLocation } from 'types/toolHistory.types';
import { LOCATION_PLACE_TYPE } from 'types/services';

import './LocationMarkers.scss';

/**
 * Muestra ubicaciones de origen y destino con íconos y banderas
 * @param origin - Ubicación de origen
 * @param destination - Ubicación de destino
 */
export const LocationMarkers = ({ origin, destination }: LocationMarkersProps) => {
  const hasOrigin = !!origin?.locationName;
  const hasDestination = !!destination?.locationName;

  return (
    <div className="locationMarkers">
      {hasOrigin && (
        <AssetLocationDisplay
          location={{ country: origin?.country, place: origin?.place as LOCATION_PLACE_TYPE }}
          locationName={origin.locationName}
          textCharactersLimit={27}
        />
      )}

      {hasOrigin && hasDestination && <IconArrow className="IconArrow" />}

      {hasDestination && (
        <AssetLocationDisplay
          location={{ country: destination?.country, place: destination?.place as LOCATION_PLACE_TYPE }}
          locationName={destination.locationName}
          textCharactersLimit={27}
        />
      )}
    </div>
  );
};

interface LocationMarkersProps {
  origin?: IToolHistoryLocation | null;
  destination?: IToolHistoryLocation | null;
}
